type Region = 'us' | 'ca';

export function parseRegion(identifier: string): Region {
  const prefix = identifier.split('_')[0];
  if (prefix === 'ca') {
    return 'ca';
  }
  return 'us';
}

export function getBaseUrl(region: Region): string {
  const useRemoteApi = String(import.meta.env.USE_REMOTE_API) === 'true';

  if (import.meta.env.DEV && !useRemoteApi) {
    return 'http://localhost:3000';
  }

  if (region === 'ca') {
    return 'https://api-ca.oncontinuum.com';
  }

  return 'https://api.oncontinuum.com';
}

const SHARING_CABLE_PATH = '/sharing/cable';

// anycable-go runs on its own port locally (bin/dev), so this cannot be derived from the API
// base URL. sharing/ cannot import from src/, so the region mapping is repeated here.
export function getCableUrl(region: Region): string {
  const explicitUrl = import.meta.env.ANYCABLE_CABLE_URL;
  if (explicitUrl) {
    return `${new URL(explicitUrl).origin}${SHARING_CABLE_PATH}`;
  }

  const useRemoteApi = String(import.meta.env.USE_REMOTE_API) === 'true';
  if (import.meta.env.DEV && !useRemoteApi) {
    const port = import.meta.env.ANYCABLE_PORT || '8090';
    return `ws://localhost:${port}${SHARING_CABLE_PATH}`;
  }

  const host =
    region === 'ca' ? 'cable-ca.oncontinuum.com' : 'cable.oncontinuum.com';

  return `wss://${host}${SHARING_CABLE_PATH}`;
}

export function getSharingApiUrl(region: Region): string {
  return `${getBaseUrl(region)}/sharing/graphql`;
}

export function getViewerApiUrl(region: Region): string {
  return `${getBaseUrl(region)}/sharing/viewer/graphql`;
}
